import OneBoxPage from "./components/page";
import { HANDLERS } from "./config";
import initService from "./init-service";
import TitleGate from "./title-gate";

export type { OneBoxPageDto } from "./components/page/OneBoxPageDto";
export { HANDLERS, OneBoxPage };

const boxService = ({ registerTargets }: any) => {
    registerTargets(HANDLERS);

    return [
        {
            target: "$INIT_SERVICES",
            handler: initService,
        },
        {
            target: "$ONE_LAYOUT_ROUTES_BEFORE",
            handler: {
                component: TitleGate,
            },
        },
    ];
};

export default boxService;
